import { ShiftPlanCalendarDateInterface } from 'base';
import { ShiftPlanMdGutterGroupInterface } from '../_interfaces/base-customer-shift-plan-md.interface';

/**
 * Collapses consecutive days sharing a label into one gutter item, expressed as an
 * explicit grid-row span so the label sits alongside the day rows it covers.
 * Shared by the organizer and the similar-inquiries calendar, which draw the same gutter.
 */
export function buildShiftPlanMdGutterGroups(
  days: ShiftPlanCalendarDateInterface[],
  labelOf: (day: ShiftPlanCalendarDateInterface) => string
): ShiftPlanMdGutterGroupInterface[] {
  const groups: { label: string; startRow: number; span: number }[] = [];

  days.forEach((day, index) => {
    const label = labelOf(day);
    const currentGroup = groups[groups.length - 1];

    if (currentGroup && currentGroup.label === label) {
      currentGroup.span++;
      return;
    }

    groups.push({ label, startRow: index + 1, span: 1 });
  });

  return groups.map(({ label, startRow, span }) => ({
    label,
    gridRow: `${startRow} / span ${span}`,
  }));
}
